<template>
  <div>
    <button class="btn btn-primary btn-sm"
        data-toggle="tooltip" 
        data-placement="top" 
        title="New"
        @click="fnShowModal()">New
    </button>

    <b-modal ref="modal" hide-footer title="Document type - new">
        <div class="d-block">
        <form v-on:submit.prevent="createNew">
            <div class="form-group">
                <input type="text" 
                    class="form-control" 
                    id="name" 
                    autocomplete="off_type"
                    placeholder=" "
                    v-model="name">
                <div class="invalid-feedback" v-if="errors.name">{{ errors.name[0] }}</div>
                <label for="name">Type</label>
            </div>
        <hr>
        <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button type="submit" class="btn btn-primary btn-sm">Save</button>
        </div>
        </form>
        </div>
    </b-modal>
  </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as documentTypeService from '../../services/documentType.service';
    export default {
        name:"ModalDocumentTypeNew",
        components: {
            
        },
        data(){
            return{
                errors:{},
                name:'',
            }
        },
        methods:{
            ...mapActions(['fetchDocumentTypeAll']),
            fnShowModal(){
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            createNew:async function(){
                let formData = new FormData();
                formData.append('name',this.name);
            try{
                const response = await documentTypeService.add(formData);
                this.hideModal();
                this.fetchDocumentTypeAll();
                messageService.fnSweetAlertSuccessToast('Document type - new', 'added successfully ');

                this.name = '';

                }catch(error){
                    switch (error.response.status){
                    case 422:
                        this.errors = error.response.data.errors;
                        break;

                    case 500:
                        messageService.fnSweetAlertErrorToast('Document type - new', error.response.data.message);
                        break;

                    default:
                            messageService.fnSweetAlertErrorToast('Document type - new', 'Something wrong');
                        break;
                    }
                }
            },
        }
    }
</script>